import React from 'react';
import { MessageModalLayout, Text } from '@wix/design-system';
import * as symbols from '@wix/santa-editor-symbols';
import * as panels from '#packages/panels';
import { translate } from '#packages/i18n';

export const MEMBER_AUTH_INSTALL_ERROR_MODAL_PANEL_NAME =
  'pageSettingsPanel.modals.memberAuthInstallErrorModal';

export interface MemberAuthInstallErrorModalProps {
  onTryAgain: () => void;
  onCancel: () => void;
  onClose: () => void;
}

export const MemberAuthInstallErrorModal: React.FC<
  MemberAuthInstallErrorModalProps
> = ({ onTryAgain, onCancel, onClose }) => (
  <panels.frames.FocusPanelFrame
    shouldHideHeader
    panelName={MEMBER_AUTH_INSTALL_ERROR_MODAL_PANEL_NAME}
  >
    <MessageModalLayout
      illustration={
        <symbols.symbol name="memberAuthInstallErrorIllustration" />
      }
      onCloseButtonClick={onClose}
      primaryButtonText={translate(
        'member_authentication_app_install_error_modal_try_again',
      )}
      primaryButtonOnClick={onTryAgain}
      secondaryButtonText={translate(
        'member_authentication_app_install_error_modal_cancel',
      )}
      secondaryButtonOnClick={onCancel}
      title={translate('member_authentication_app_install_error_modal_title')}
      content={
        <Text>
          {translate(
            'member_authentication_app_install_error_modal_description',
          )}
        </Text>
      }
    />
  </panels.frames.FocusPanelFrame>
);
